<template>
    <div class="emp-card" :key="`emp-${employeeId}`">
        <div class="emp-form-wrapper">
            <DxAccordion class="emp-acc" :data-source="sections" :multiple="false" :animation-enabled="true"
                :defer-rendering="false" :focus-state-enabled="false">
                <template #title="{ data }">
                    <div class="emp-acc__title">
                        <span class="emp-acc__title-text">{{ data.title }}</span>
                        <span class="emp-acc__chev" aria-hidden="true"></span>
                    </div>
                </template>

                <template #item="{ data }">
                    <div class="emp-acc__panel">
                        <template v-if="data.key === 'intretinuti'">
                            <GridIntretinuti :employee-id="employeeId" :employee-row="employeeRow" :key="employeeId" />
                        </template>
                        <template v-if="data.key === 'certificateMedicale'">
                            <GridCertificateMedicale :employee-id="employeeId" :employee-row="employeeRow"
                                :key="employeeId" />
                        </template>
                        <template v-if="data.key === 'studii'">
                            <GridStudii :employee-id="employeeId" :employee-row="employeeRow" :key="employeeId" />
                        </template>
                        <template v-if="data.key === 'contracte'">
                            <GridContracteMunca :employee-id="employeeId" :employee-row="employeeRow"
                                :key="employeeId" />
                        </template>

                        <DxForm v-else :label-location="'top'" :col-count="2"
                            :col-count-by-screen="{ xs: 1, sm: 2, md: 2 }" :min-col-width="220" :styling-mode="'filled'"
                            class="emp-form">
                            <template v-if="data.key === 'contracte'">
                                <!-- DxSimpleItem... -->
                            </template>

                            <template v-else-if="data.key === 'fisiere'">
                                <!-- DxSimpleItem... -->
                            </template>

                            <template v-else-if="data.key === 'studii'">
                                <!-- DxSimpleItem... -->
                            </template>
                        </DxForm>
                    </div>
                </template>

            </DxAccordion>
        </div>
    </div>
</template>

<script lang="ts">
import DxButton, { type DxButtonTypes } from 'devextreme-vue/button';
import { defineComponent, readonly } from 'vue'
import { DxAccordion } from 'devextreme-vue/accordion'
import { DxForm, DxSimpleItem } from 'devextreme-vue/form'
import PER_Employees from '@/services/PER/PER_Employees'
import ToolbarForm from '@/components/utils/toolbar-form.vue';
import PER_ActiveEmployees from '@/services/PER/PER_ActiveEmployees';
import {
    DxDataGrid,
    DxColumn,

} from 'devextreme-vue/data-grid';
import GridIntretinuti from '../GridIntretinuti.vue';
import GridCertificateMedicale from '../GridCertificateMedicale.vue';
import GridStudii from '../Salarizare/GridStudii.vue';
import GridContracteMunca from '../GridContracteMunca.vue';
export default defineComponent({
    components: { DxAccordion, DxForm, DxSimpleItem, ToolbarForm, DxButton, DxDataGrid, DxColumn, GridIntretinuti, GridCertificateMedicale, GridStudii, GridContracteMunca },
    props: {
        employeeId: { type: String, required: true },
        employeeRow: { type: Object, default: null }
    },
    data() {
        return {
            employee: {
                Id: '',
                OldId: null,
                Name: '',
                Surname: '',
                Descr: null,
                BornCntryId: null,
                BornPlace: null,
                BornDate: "",
                Cnp: '',
                InternalCode: '',
                DocIdentSerie: '',
                DocIdentNo: null,
                DocIdentIssuer: null,
                DocIdentIssueDate: null,
                Sex: '',
                MrtStatus: null,
                Handicap: null,
                CardSalary: false,
                CardAccNo: null,
                CardNo: null,
                DrvLicense: null,
                StudiesLevel: null,
                Vechime: null,
                SalBaza: '',
                OreContract: null,
                WorkGrade: '',
                AddressId: '',
                PositionId: '',
                ProbationDate: null,
                ProbationPeriod: null,
                Student: null,
                StudentYear: null,
                EmpgroupId: '',
                ZileConc: '',
                StructId: '',
                MeserieId: '',
                Sters: null,
                PontajSchemaId: null,
                CardBankId: null,
                IsSindicat: null,
                SporConditii: null,
                NaturaAngajat: null,
                SporPermanent: null,
                DataModificare: null,
                BornPlaceId: null,
                Foto: null,
                CasaSn: '',
                DataExpiraContract: null,
                Pensionar: false,
                FunctieDeBaza: false,
                DataStartVechime: null,
                Apatrid: null,
                CnpVechi: null,
                DetaliiSalariatStrain: null,
                Mentiuni: null,
                DocIdentTip: null,
                TaraNationalitateId: null,
                TipAutorizatie: null,
                DataInceputAutorizatie: null,
                DataSfarsitAutorizatie: null,
                TransferInRevisal: null,
                UserCreareRevisal: null,
                DataCreareRevisal: null,
                UserModificareRevisal: null,
                DataModificareRevisal: null,
                DocIdentExpiryDate: null,
                DataStartVechimeFirma: null,
                StructuraId: '',
                AccesCardId: null,
                Observations: null,
                NrCrtOrg: null,
                PontajUsrId: null,
                Foto2: null,
                D112AsigCi: false,
                D112AsigSo: true,
                D112AsigScu: null,
                D112AsigExc: false,
                PontajOraInceput: '',
                PontajPauzaMinute: '',
                D112TipAsigurat: '',
                SemnaturaImg: null,
                Localitate: ''

            },
            listaIntretinuti: [],
            isEditing: false,
            employeeOriginalIdent: null,
            dsStructuri: [],
            dsLookup: [],
            sections: [
                { key: 'contracte', title: 'Contracte' },
                { key: 'fisiere', title: 'Fisiere' },
                { key: 'studii', title: 'Studii' },
                { key: 'intretinuti', title: 'Intretinuti' },
                { key: 'retineri', title: 'Retineri' },
                { key: 'certificateMedicale', title: 'Certificate Medicale' },
                { key: 'istoricZileBoala', title: 'Istoric Zile Boala' },
                { key: 'concedii', title: 'Concedii' },
                { key: 'delegari', title: 'Delegari' },
                { key: 'proiecte', title: 'Proiecte' },
                { key: 'evaluari', title: 'Evaluari' },
                { key: 'centreCost', title: 'Centre de cost' },
                { key: 'adrese', title: 'Adrese' },
                { key: 'vouchere', title: 'Vouchere' },
                { key: 'alerteDiverse', title: 'Alerte Diverse' },
                { key: 'directionareImpozit', title: 'Directionare Impozit' },
                { key: 'istoricAngajat', title: 'Istoric Angajat' },

            ],

        }
    },
    watch: {
        employeeId: {
            immediate: true,
            handler(newId: string) {
                if (newId) this.getAngajatiByID(newId)
            }
        }
    },
    mounted() {
        this.getDepartamente();
        this.getLookup(this.employeeId);

    },
    methods: {
        async getAngajatiByID(id: string) {
            const { data } = await PER_Employees.getByID(id);
            const raw = Array.isArray(data)
                ? (data[0] ?? {})
                : (data?.value ? (data.value[0] ?? {}) : data ?? {});

            const row: any = {};
            for (const k in raw) row[k] = raw[k];

            Object.assign(this.employee, row);
        },
        onEditIdentClick() {
            if (!this.isEditing) {
                this.employeeOriginalIdent = JSON.parse(JSON.stringify(this.employee));
                this.isEditing = true;
                return;
            }
            this.isEditing = false;
            this.employeeOriginalIdent = null;
        },
        onCancelIdent() {
            if (this.employeeOriginalIdent) {

                Object.assign(this.employee, this.employeeOriginalIdent);
            }
            this.isEditing = false;
            this.employeeOriginalIdent = null;
        },
        getDepartamente() {
            PER_ActiveEmployees
                .getDepartamente()
                .then((response: any) => {
                    this.dsStructuri = response.data;
                })
                .catch((e: Error) => console.log(e));
        },
        getLookup(employeeId: string) {
            PER_ActiveEmployees
                .getLookup(employeeId)
                .then((response: any) => {
                    this.employee = response.data;
                })
                .catch((e: Error) => console.log(e));
        }



    }

})
</script>

<style scoped>
/* card */
.emp-card {
    background: var(--dx-color-bg, #fff);
    border: 1px solid rgba(0, 0, 0, .08);
    box-shadow: 0 6px 18px rgba(0, 0, 0, .06);
    padding: 20px 16px 8px;
}

.emp-card__header {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 10px;
}

.emp-card__subtitle {
    opacity: .75;
    font-size: .95rem;
}

/* scroll container */
.emp-form-wrapper {
    max-height: 75vh;
    overflow-y: auto;
    overflow-x: hidden;
    padding-right: 8px;
    scroll-behavior: smooth;
    scrollbar-width: thin;
}

.emp-form-wrapper::-webkit-scrollbar {
    width: 6px;
}

.emp-form-wrapper::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, .25);

}

/* ACCORDEON */
.emp-acc :deep(.dx-accordion-item) {
    border: 1px solid rgba(0, 0, 0, .06);
    /* border-radius: 12px; */
    margin-bottom: 10px;
    overflow: hidden;
    background: #fff;
}

.emp-acc :deep(.dx-accordion-item-opened) {
    box-shadow: 0 8px 24px rgba(0, 0, 0, .06);
    border-color: rgba(0, 0, 0, .08);
}

.emp-acc__title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 12px;
    font-weight: 600;
    font-size: .95rem;
}

.emp-acc__title-text {
    opacity: .85;
}

.emp-acc__chev {
    width: 10px;
    height: 10px;
    position: relative;
}

/* panel interior */
.emp-acc__panel {
    padding: 10px 12px 14px;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.015), transparent);
}

/* form styling fin */
.emp-form :deep(.dx-field-item-label-text) {
    font-size: .86rem;
    opacity: .8;
}

.emp-form :deep(.dx-texteditor),
.emp-form :deep(.dx-datebox) {
    margin-top: 4px;
}

.form-actions-right {
    display: flex;
    justify-content: flex-end;
}

.ml-2 {
    margin-left: 0.5rem;
}
</style>
